"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.groupDefinitions = void 0;
/** WTM Role Management */
const originalGroupDefinitions = [
    {
        id: 'Manager',
        displayName: 'Manager',
        precedence: 4,
        policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
        inheritPoliciesNames: ['systemManagementDefintion'],
    },
    {
        id: 'Farmer',
        displayName: 'Farmer',
        precedence: 4,
        policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
        inheritPoliciesNames: ['systemManagementDefintion'],
    },
    {
        id: 'FarmManager',
        displayName: 'Farm Manager',
        precedence: 4,
        policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
        inheritPoliciesNames: ['systemManagementDefintion'],
    },
    {
        id: 'Installer',
        displayName: 'Installer',
        precedence: 10,
        policies: [],
        inheritPoliciesNames: ['userPolicyDefintion'],
    },
    {
        id: 'WaterEngineeringSpecialist',
        displayName: 'Water Engineering Specialist',
        precedence: 15,
        policies: [],
        inheritPoliciesNames: ['userPolicyDefintion'],
    },
    {
        id: 'FarmWorker',
        displayName: 'Farm Worker',
        precedence: 20,
        policies: ['deviceControllApiPolicy'],
        inheritPoliciesNames: ['userPolicyDefintion'],
    },
];
/** WTG Role Management */
const v3baseRoles = [
    {
        id: 'Admin',
        displayName: 'Admin',
        precedence: 4,
        policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
        inheritPoliciesNames: ['systemManagementDefintion'],
    },
    {
        id: 'Farmer',
        displayName: 'Farmer',
        precedence: 4,
        policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
        inheritPoliciesNames: ['systemManagementDefintion'],
    },
    {
        id: 'FarmManager',
        displayName: 'Farm Manager',
        precedence: 4,
        policies: ['systemManagementRoleAdditions', 'systemManagementApiPolicy'],
        inheritPoliciesNames: ['systemManagementDefintion'],
    },
    {
        id: 'FarmWorker',
        displayName: 'Farm Worker',
        precedence: 20,
        policies: ['deviceControllApiPolicy'],
        inheritPoliciesNames: ['userPolicyDefintion'],
    },
];
let groupDefinitions = [...v3baseRoles, ...originalGroupDefinitions];
exports.groupDefinitions = groupDefinitions;
